module.exports = __webpack_public_path__ + "static/img/bg_fwys@2x.8456fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/bg_fwys@2x.png
// module id = Emvu
// module chunks = 70